<template>
    <div class="form-errors" v-if="errors && errors.length">
        <ul class="list-unstyled">
            <li v-for="(error, i) in errors" :key="'form-error-' + i">
                <template v-if="Array.isArray(error)">
                    <ul class="list-unstyled" v-for="(message, k) in error" :key="'form-error-message-' + k">
                        <li class="text-danger"><small>{{ message }}</small></li>
                    </ul>
                </template>
                <template v-else>
                    <span class="text-danger"><small>{{ error }}</small></span>
                </template>
            </li>
        </ul>
    </div>
</template>
<script setup>
import { computed } from 'vue';
import { usePage } from '@inertiajs/inertia-vue3';
const props = defineProps({
    errors: {
        type: Object,
        default: () => { },
    },
    exclude: {
        type: Array,
        default: [],
    },
});
const errors = computed(() => {
    const data = _.get(usePage(), "props.value.errors");
    return _.filter(data, (element, index) => !props.exclude.includes(index));
});
</script>
